import { Text } from '@components/primitives/Text'
import { useEffect } from 'react'
import type { InViewHookResponse } from 'react-intersection-observer'

type TrialListingPageRefs = {
  [sectionId in ListingPageNavbarSections]: InViewHookResponse
}

export type ListingPageNavbarSections =
  | 'summary' // we have this
  | 'eligibilityCriteria' // we have this
  | 'timeline' // we have this
  | 'treatmentDetails' // These are the Efficacy + side effect charts  AND the awards
  | 'trialDesign' // This is the the doughnut
  | 'findASite' // map component + who is running the trial
  | 'mediaLibrary' // todo
  | 'faq' // FAQ, plus pie charts plus why did patients apply  +  references + links etc, vidoes!?

export const NavbarTableOfContents = ({
  sectionRefs,
}: {
  sectionRefs: TrialListingPageRefs
}) => {
  useEffect(() => {
    const entry = sectionRefs.eligibilityCriteria.entry
    if (!entry) return
  }, [sectionRefs.eligibilityCriteria.entry])

  return (
    <nav className='flex gap-6'>
      <NavbarItem
        hook={sectionRefs.summary}
        sectionId='summary'
        text='Summary'
      />
      <NavbarItem
        hook={sectionRefs.eligibilityCriteria}
        sectionId='eligibilityCriteria'
        text='Eligibility'
      />
      <NavbarItem
        hook={sectionRefs.timeline}
        sectionId='timeline'
        text='Timeline'
      />
      <NavbarItem
        hook={sectionRefs.treatmentDetails}
        sectionId='treatmentDetails'
        text='Treatment'
      />
      <NavbarItem
        hook={sectionRefs.trialDesign}
        sectionId='trialDesign'
        text='Design'
      />
      <NavbarItem
        hook={sectionRefs.findASite}
        sectionId='findASite'
        text='Locations'
      />
      <NavbarItem
        hook={sectionRefs.mediaLibrary}
        sectionId='mediaLibrary'
        text='Media'
      />
      <NavbarItem hook={sectionRefs.faq} sectionId='faq' text='FAQ' />
    </nav>
  )
}

export const NavbarItem = ({
  hook,
  sectionId,
  text,
}: {
  hook: InViewHookResponse
  sectionId: ListingPageNavbarSections
  text: string
}) => {
  if (!hook.entry) {
    // Don't render if the content is not on the page
    return null
  }
  const color = hook.inView ? 'text-primary500' : 'text-neutral600'

  return (
    <a href={`#${sectionId}`}>
      <Text
        className={`${
          hook.inView ? 'font-semibold' : 'hover:text-primary500'
        } ${color}`}
        styleName='p'
        value={text}
      />
    </a>
  )
}
